/**
 * @generated SignedSource<<6187d3f40c7c92e3e9f2fc2feca8c638>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobSkillsFields_SkillsQuery$variables = {
  editable: boolean;
};
export type JobSkillsFields_SkillsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"JobSkillsFields_SkillsFragment">;
};
export type JobSkillsFields_SkillsQuery = {
  response: JobSkillsFields_SkillsQuery$data;
  variables: JobSkillsFields_SkillsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "editable"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "JobSkillsFields_SkillsQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "JobSkillsFields_SkillsFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JobSkillsFields_SkillsQuery",
    "selections": [
      {
        "condition": "editable",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1000
              }
            ],
            "concreteType": "SkillConnection",
            "kind": "LinkedField",
            "name": "skills",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SkillEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Skill",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Industry",
                        "kind": "LinkedField",
                        "name": "industries",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rawId",
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "skills(first:1000)"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "386bc02f8847b0c6c54c1ff389e6e69b",
    "id": null,
    "metadata": {},
    "name": "JobSkillsFields_SkillsQuery",
    "operationKind": "query",
    "text": "query JobSkillsFields_SkillsQuery(\n  $editable: Boolean!\n) {\n  ...JobSkillsFields_SkillsFragment\n}\n\nfragment JobSkillsFields_SkillsFragment on Query {\n  skills(first: 1000) @include(if: $editable) {\n    edges {\n      node {\n        id\n        name\n        industries {\n          rawId\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7437adf660683a85ba31894b2a438c47";

export default node;
